import { render, staticRenderFns } from "./Devolutions.vue?vue&type=template&id=ada57efe"
import script from "./Devolutions.vue?vue&type=script&lang=js"
export * from "./Devolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports